import { StartDatePicker } from '@common/components';
import { DatesSlider, getNextSevenDays } from '@common/components/DatesSlider';
import moment, { Moment } from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { SpaPackageType } from 'shared-types/SpaPackage';

type DateSelectorProps = {
  activeDate: Moment;
  setActiveDate: (value: Moment) => Promise<void>;
  change: (fieldName: string, value: string) => void;
  entity: SpaPackageType;
  loadingDates: string[];
  onStartDateChange: (startDate: string) => void;
  selectedDate: string;
  isLoading: boolean;
  clearFormField?: (fieldName: string) => void;
};

export const DateSelector: FC<DateSelectorProps> = ({
  activeDate,
  entity,
  isLoading,
  setActiveDate,
  change,
  loadingDates,
  onStartDateChange,
}) => {
  const { timeslots = {}, telephoneOnly = false } = entity || {};

  const sevenDays = getNextSevenDays(activeDate).map(({ date, dateString }) => ({
    date,
    dateString,
    disableDate: !telephoneOnly && timeslots[date.format('YYYY-MM-DD')]?.length === 0,
  }));

  const handlePickerChange = (date: Moment) => {
    const dateString = date.format('YYYY-MM-DD');
    setActiveDate(date);
    change('date', dateString);
    onStartDateChange(dateString);
    setVisitDate(date.format('YYYY-MM-DD'));
  };

  const handleSliderChange = (date: Moment) => {
    change('date', date.format('YYYY-MM-DD'));
    setVisitDate(date.format('YYYY-MM-DD'));
  };

  const firstActiveDateString = sevenDays.find((day) => !day.disableDate)?.dateString;
  const [visitDate, setVisitDate] = useState(firstActiveDateString);
  useEffect(() => {
    if (visitDate) {
      change('date', visitDate);
    }
  }, [visitDate]);

  useEffect(() => {
    if (visitDate !== firstActiveDateString) {
      setVisitDate(firstActiveDateString);
    }
  }, [firstActiveDateString]);
  return (
    <>
      <StartDatePicker
        input={{ value: activeDate, onChange: handlePickerChange }}
        pickerTextId="common.calendar.changeWeekCTA"
      />
      <DatesSlider
        key={activeDate.format('YYYY-MM-DD')}
        dates={sevenDays}
        input={{ value: moment(visitDate), onChange: handleSliderChange }}
        visitDate={moment(visitDate)}
        loadingDates={loadingDates}
        telephoneOnly={telephoneOnly}
        isLoading={isLoading}
      />
    </>
  );
};
